// AI provider → brand color mapping

export interface ProviderColorConfig {
  dotColor: string;
  pulseColor: string;
  radarColor: string;
}

const ANTHROPIC_COLORS: ProviderColorConfig = {
  dotColor: "bg-orange-400",
  pulseColor: "bg-orange-400 dark:bg-orange-400",
  radarColor: "border-orange-400/50 dark:border-orange-400/50",
};

const OPENAI_COLORS: ProviderColorConfig = {
  dotColor: "bg-emerald-400",
  pulseColor: "bg-emerald-400 dark:bg-emerald-400",
  radarColor: "border-emerald-400/50 dark:border-emerald-400/50",
};

const GOOGLE_COLORS: ProviderColorConfig = {
  dotColor: "bg-violet-400",
  pulseColor: "bg-violet-400 dark:bg-violet-400",
  radarColor: "border-violet-400/50 dark:border-violet-400/50",
};

const DEEPSEEK_COLORS: ProviderColorConfig = {
  dotColor: "bg-sky-400",
  pulseColor: "bg-sky-400 dark:bg-sky-400",
  radarColor: "border-sky-400/50 dark:border-sky-400/50",
};

const XIAOMI_COLORS: ProviderColorConfig = {
  dotColor: "bg-orange-500",
  pulseColor: "bg-orange-500 dark:bg-orange-500",
  radarColor: "border-orange-500/50 dark:border-orange-500/50",
};

const PROVIDER_COLORS: Record<string, ProviderColorConfig> = {
  anthropic: ANTHROPIC_COLORS,
  bedrock: ANTHROPIC_COLORS,
  claude: ANTHROPIC_COLORS,
  codex: OPENAI_COLORS,
  deepseek: DEEPSEEK_COLORS,
  gemini: GOOGLE_COLORS,
  google: GOOGLE_COLORS,
  mimo: XIAOMI_COLORS,
  minimax: OPENAI_COLORS,
  openai: OPENAI_COLORS,
  openrouter: OPENAI_COLORS,
  vertex: GOOGLE_COLORS,
  xiaomi: XIAOMI_COLORS,
};

const DEFAULT_PROVIDER_COLORS: ProviderColorConfig = {
  dotColor: "bg-sky-500",
  pulseColor: "bg-sky-500 dark:bg-sky-400",
  radarColor: "border-sky-500/50 dark:border-sky-400/50",
};

/** Map an AI provider string to brand-colored dot/pulse classes. */
export function getProviderColors(
  provider: string | null,
): ProviderColorConfig {
  if (provider && provider in PROVIDER_COLORS) {
    return PROVIDER_COLORS[provider];
  }
  return DEFAULT_PROVIDER_COLORS;
}
